module.exports = __webpack_public_path__ + "img/live_bg.94b16aa9.png";